export default "__VITE_ASSET__Bf59ZUF3__"